import { useMemo, useState } from "react";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import DraftSubmissionAuthInfo from "./draftSubmissionAuthInfo";
import DraftSubmissionButtonsGroup from "./draftSubmissionButtonsGroup";
import DraftSubmissionCptTable from "./draftSubmissionCptTable";
import DraftSubmissionTabs from "./draftSubmissionTabs";

interface DraftSubmissionBodyProps {
  draftSubmission: DraftSubmission[];
}

const DraftSubmissionBody = (props: DraftSubmissionBodyProps) => {
  const [activeAuthId, setActiveAuthId] = useState<string | undefined>(
    props.draftSubmission[0].id ?? "",
  );
  const activeDraftSubmission = useMemo(() => {
    return props.draftSubmission.find(
      (draftSubmission) => draftSubmission.id === activeAuthId,
    );
  }, [props.draftSubmission, activeAuthId]);
  return (
    <div className="draft-submission-body--container flex h-full flex-col gap-[1.125rem] overflow-hidden">
      <div className="draft-submission-body--top overflow-y-auto border-b border-primaryGray-15">
        <DraftSubmissionTabs
          draftSubmissions={props.draftSubmission}
          activeAuthId={setActiveAuthId}
        />
      </div>
      <div className="draft-submission-body--middle flex flex-1 flex-col gap-4 overflow-auto">
        <DraftSubmissionAuthInfo authInformation={activeDraftSubmission} />
        <DraftSubmissionCptTable draftSubmission={activeDraftSubmission} />
      </div>
      <div className="draft-submission-body--bottom flex flex-row justify-end gap-2 border-t-1 border-primaryGray-15 pt-3">
        <DraftSubmissionButtonsGroup draftSubmission={activeDraftSubmission} />
      </div>
    </div>
  );
};

export default DraftSubmissionBody;
